export default class OtpModel {
  created_at: string | null;
  device_id: string | null;
  firebase_token: string | null;
  id: number | null;
  jwt_token: string | null;
  updated_at: string | null;
  user_id: number | null;
  constructor() {
    this.created_at = null;
    this.device_id = "";
    this.firebase_token = "000";
    this.id = null;
    this.jwt_token = null;
    this.updated_at = null;
    this.user_id = null;
  }
}
